/** Fired after localStorage USER is updated (login, /me, token refresh) so UI re-reads permissions. */
export const AUTH_USER_CHANGED_EVENT = 'tsoft-auth-user-changed';

/** Fired when access token changes — SSE and other token-bound connections should reconnect. */
export const AUTH_TOKEN_CHANGED_EVENT = 'tsoft-auth-token-changed';

export function notifyAuthUserChanged(): void {
  window.dispatchEvent(new Event(AUTH_USER_CHANGED_EVENT));
}

export function notifyAuthTokenChanged(): void {
  window.dispatchEvent(new Event(AUTH_TOKEN_CHANGED_EVENT));
}
